export const MODAL_NAME = 'surveyMonkey';
export const CONSIDER_LEAVING_DIFF = 30;
export const INIT_MODAL = 'src/components/SurveyMonkey/INIT_MODAL';
export const SHOW_MODAL = 'src/components/SurveyMonkey/SHOW_MODAL';
